var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "22px",
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "010B217E-DF80-4260-A139-E67FA1DDD918") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Perfil-Portfolio",
    transform: "translate(-249.000000, -308.000000)",
    fill: "#B5B5B5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(212.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Location",
    transform: "translate(37.000000, 219.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.10702703,1.19555556 C4.32152009,1.31645145 0.470572078,5.18641649 0.35027027,9.99555556 C0.431460803,11.4174437 0.821692658,12.8041844 1.49351351,14.0582222 L1.56162162,14.1804444 C6.85459459,22.7066667 8.43567568,22.7066667 9.10702703,22.7066667 C10.1578378,22.7066667 11.2913514,21.9635556 13.9718919,18.1746667 C15.3778378,16.2191111 16.5843243,14.2635556 16.632973,14.1755556 L16.7010811,14.0582222 C17.3796827,12.8057663 17.776581,11.4189409 17.8637838,9.99555556 C17.743482,5.18641649 13.892534,1.31645145 9.10702703,1.19555556 L9.10702703,1.19555556 Z M15.4313514,13.4177778 C15.4313514,13.4177778 10.5664865,21.24 9.10702703,21.24 C7.64756757,21.24 2.7827027,13.4177778 2.7827027,13.4177778 C2.21713365,12.3606767 1.88525378,11.1933609 1.80972973,9.99555556 C1.80972973,5.94546739 5.07684101,2.66222222 9.10702703,2.66222222 C13.137213,2.66222222 16.4043243,5.94546739 16.4043243,9.99555556 C16.3242869,11.1944685 15.9874109,12.3618463 15.4167568,13.4177778 L15.4313514,13.4177778 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10702703,5.59555556 C6.95759449,5.59555556 5.21513514,7.34661965 5.21513514,9.50666667 C5.21513514,11.6667137 6.95759449,13.4177778 9.10702703,13.4177778 C11.2564596,13.4177778 12.9989189,11.6667137 12.9989189,9.50666667 C12.9989189,7.34661965 11.2564596,5.59555556 9.10702703,5.59555556 Z M9.10702703,11.9511111 C7.76363169,11.9511111 6.67459459,10.8566961 6.67459459,9.50666667 C6.67459459,8.15663728 7.76363169,7.06222222 9.10702703,7.06222222 C10.4504224,7.06222222 11.5394595,8.15663728 11.5394595,9.50666667 C11.5394595,10.8566961 10.4504224,11.9511111 9.10702703,11.9511111 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.372f5029cf7b3b8f0aa8ec0c55ed4fe2.svg";
export { ForwardRef as ReactComponent };